import { useRef, useState } from "react";

export const useIsFocused = () => {
  const [focused, setFocused] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleFocus = () => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    setFocused(true);
  };

  const handleBlur = () => {
    timeoutRef.current = setTimeout(() => setFocused(false), 0);
  };

  return [focused, { onFocus: handleFocus, onBlur: handleBlur }] as const;
};
